
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"#0037FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.63 6.665c-.063-.337-.195-.526-.3-.623a.407.407 0 00-.275-.123H1.863v-2.4h2.192c1.459 0 2.626 1.12 2.929 2.677.165.718.356 1.526.563 2.383.185.77.383 1.58.584 2.4.417 1.699.851 3.44 1.23 4.96.534 2.143.958 3.846 1.071 4.37l.01.048c.083.48.454.745.75.745h11.991c1.207 0 2.332-.878 2.653-2.236l1.861-7.887H8.131l-.584-2.4h20.405c.7 0 1.34.342 1.742.889.4.542.535 1.235.382 1.883l-1.904 8.067c-.556 2.355-2.582 4.083-4.989 4.084h-11.99c-1.65 0-2.853-1.292-3.11-2.708-.124-.563-.534-2.205-1.05-4.276-.756-3.028-1.741-6.973-2.393-9.806a1.18 1.18 0 01-.01-.047zm9.175 17.88a1.968 1.968 0 10-.001 3.937 1.968 1.968 0 000-3.936zm8.611 0a1.968 1.968 0 100 3.937 1.968 1.968 0 000-3.936z","fill":"#1F4FFF"}})])
          )
        }
      }
    